
  import { defineComponent } from 'vue';
  import useVuelidate from '@vuelidate/core';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';

  export default defineComponent({
    name: 'CalculationForm',
    components: {
      ButtonComponent,
    },
    emits: ['submit'],
    props: {
      buttonText: {
        type: String,
        default: 'Загрузить данные',
      },
      buttonLoadingText: {
        type: String,
        default: 'Загрузка...',
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    setup() {
      return { v$: useVuelidate() };
    },
    computed: {
      getButtonText() {
        return this.isLoading ? this.buttonLoadingText : this.buttonText;
      },
      getIsDisabledForm() {
        return this.isLoading || this.disabled;
      },
    },
    methods: {
      onSubmit() {
        this.v$.$touch();
        if (this.v$.$invalid) return;
        this.$emit('submit');
      },
    },
  });
